// extracted by mini-css-extract-plugin
module.exports = {"mapButtonWrapper":"map-button_mapButtonWrapper__JYon4","mapButton":"map-button_mapButton__jziXb","text":"map-button_text__13HJG"};